<template>
  <div class="search-form">
    <el-form :model="formInfo" ref="FormInfoRef" inline>
      <el-form-item
        label="选择分公司"
        prop="branchCompany"
        v-if="
          [1].includes(roleInfo.type) &&
          !['客服部', '常规客服部'].includes(roleInfo.superDepartmentName)
        ">
        <el-select
          v-model="value6"
          placeholder="请选择"
          value-key="id"
          clearable
          @change="shopChange6"
          filterable>
          <el-option
            v-for="item in arr6"
            :key="item.company_id"
            :label="item.companyName"
            :value="item"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="选择子公司"
        prop="sonCompany"
        v-if="[2, 1].includes(roleInfo.type)">
        <el-select
          v-model="value7"
          placeholder="请选择"
          value-key="id"
          clearable
          @change="shopChange7"
          filterable>
          <el-option
            v-for="item in arr7"
            :key="item.company_id"
            :label="item.companyName"
            :value="item"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择分部门" v-if="!disabledInput2">
        <el-select
          v-model="value2"
          filterable
          placeholder="请选择"
          value-key="id"
          clearable
          @change="shopChange2">
          <el-option
            v-for="item2 in arr1"
            :key="item2.value"
            :label="item2.departmentName"
            :value="item2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择组" v-if="!disabledInput3">
        <el-select
          v-model="value3"
          filterable
          placeholder="请选择"
          value-key="id"
          clearable
          @change="shopChange3">
          <el-option
            v-for="item3 in arr2"
            :key="item3.value"
            :label="item3.groupName"
            :value="item3"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择员工" v-if="!disabledInput4">
        <el-select
          v-model="value4"
          filterable
          placeholder="请选择"
          value-key="id"
          clearable
          @change="shopChange4">
          <el-option
            v-for="item4 in arr3"
            :key="item4.value"
            :label="item4.roleUserName"
            :value="item4"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择商家">
        <el-select
          v-model="value5"
          filterable
          placeholder="请选择"
          value-key="id"
          clearable
          @change="shopChange5">
          <el-option
            v-for="item5 in arr4"
            :key="item5.merchantId"
            :label="item5.merchantName"
            :value="item5"
            :style="{ color: item5.state === 0 ? 'red' : '' }"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择店铺" v-if="!exclude.includes('value8')">
        <el-select
          v-model="value8"
          filterable
          placeholder="请选择"
          clearable
          value-key="id"
          @change="shopChange8">
          <el-option
            v-for="item in arr8"
            :key="item.id"
            :label="item.shop_name"
            :value="item"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="开始日期" prop="startTime">
        <el-date-picker
          v-model="formInfo.startTime"
          align="right"
          type="datetime"
          placeholder="选择日期"
          format="yyyy-MM-dd HH:mm:ss"
          @change="onStartTimeChange"
          :picker-options="pickerOptions"></el-date-picker>
        <!-- @change="startTime" -->
      </el-form-item>

      <el-form-item label="结束日期" prop="endTime">
        <el-date-picker
          v-model="formInfo.endTime"
          align="right"
          type="datetime"
          placeholder="选择日期"
          format="yyyy-MM-dd HH:mm:ss"
          @change="onEndTimeChange"
          :picker-options="pickerOptions"></el-date-picker>
      </el-form-item>

      <slot name="formItem"></slot>

      <el-form-item>
        <el-button type="primary" style="margin-left: 10px" @click="onSearch">
          搜索
        </el-button>
      </el-form-item>
    </el-form>

    <slot></slot>
  </div>
</template>

<script>
import { Baseurl, ajaxPost } from '@/api/api/api'

export default {
  props: {
    exclude: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      roleInfo: null,
      formInfo: {
        companyId: '',
        staffId: '', // 取rid值
        merchantId: '', // 商户id
        startTime: '', // 开始时间
        endTime: '' // 结束时间
      },
      value2: '', // 分部门
      value3: '', // 组
      value4: '', // 员工
      value5: '', // 店铺
      value6: '', // 分公司
      value7: '', // 子公司
      value8: '', // 子公司

      arr1: [], // 分部门
      arr2: [], // 组
      arr3: [], // 员工
      arr4: [], // 店铺（shopee是商家）
      arr8: [], // 店铺
      arr5: [], // 全球商品状态
      arr6: [], // 分公司
      arr7: [], // 子公司
      disabledInput2: '',
      disabledInput3: '',
      disabledInput4: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '本月',
            onClick: (picker) => {
              const date = new Date()
              picker.$emit('pick', date)
              this.calculationDate()
            }
          },
          {
            text: '上一月',
            onClick: (picker) => {
              const date = new Date()
              picker.$emit('pick', date)
              this.calculationDate(-1)
            }
          },
          {
            text: '上两月',
            onClick: (picker) => {
              const date = new Date()
              picker.$emit('pick', date)
              this.calculationDate(-2)
            }
          },
          {
            text: '上三月',
            onClick: (picker) => {
              const date = new Date()
              picker.$emit('pick', date)
              this.calculationDate(-3)
            }
          }
        ]
      }
    }
  },
  watch: {},
  created() {
    this.roleInfo = JSON.parse(localStorage.getItem('role'))
    this.formInfo.companyId = this.roleInfo.company_id
    this.init()
  },
  methods: {
    calculationDate(type = 0) {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      // 计算新的月份和年份，确保处理负数和跨年的情况
      const newYear = year + Math.floor((month + type - 1) / 12)
      const newMonth = ((month + type - 1 + 12) % 12) + 1
      this.formInfo.startTime = `${newYear}-${newMonth
        .toString()
        .padStart(2, '0')}-01 00:00:00`

      const prevStamp =
        new Date(year, month + type, day).getTime() - 3600 * 1000 * 24 * day
      const prevMonth = `${new Date(prevStamp).getFullYear()}-${
        new Date(prevStamp).getMonth() + 1
      }-${new Date(prevStamp).getDate()}`
      this.formInfo.endTime = `${prevMonth} 23:59:59`
    },
    async init() {
      const payload = {
        rid: this.roleInfo.rid,
        companyId: this.roleInfo.company_id,
        system: this.roleInfo.system
      }
      const data = await this.fetchNextList(payload)
      if (data) {
        this.arr = data.next
        this.bizhong =
          this.arr && this.arr.length > 0 && this.arr[0].currencyCode
            ? this.arr[0].currencyCode
            : 'CNY'
        const { type: companyType, superDepartmentName, system } = this.roleInfo
        if (
          companyType === 1 &&
          !['客服部', '常规客服部'].includes(superDepartmentName)
        ) {
          this.disabledInput2 = false
          this.disabledInput3 = false
          this.disabledInput4 = false
          this.arr6 = data.next
        } else if (
          companyType === 2 ||
          (companyType === 1 &&
            ['客服部', '常规客服部'].includes(superDepartmentName))
        ) {
          this.disabledInput2 = false
          this.disabledInput3 = false
          this.disabledInput4 = false
          this.arr7 = data.next
        } else if (
          system === 1 ||
          (companyType === 3 &&
            system === 5 &&
            superDepartmentName === '财务部') ||
          (companyType === 3 &&
            system === 5 &&
            superDepartmentName === '人事部')
        ) {
          this.disabledInput2 = false
          this.disabledInput3 = false
          this.disabledInput4 = false
          this.arr1 = data.next
        } else if (system === 2) {
          this.disabledInput2 = false
          this.disabledInput3 = false
          this.disabledInput4 = false
          this.arr1 = data.next
        } else if (system === 3) {
          this.disabledInput2 = true
          this.disabledInput3 = false
          this.disabledInput4 = false
          this.arr2 = data.next
        } else if (system === 4) {
          this.disabledInput2 = true
          this.disabledInput3 = true
          this.disabledInput4 = false
          this.arr3 = data.next
        } else if (system === 5) {
          this.disabledInput2 = true
          this.disabledInput3 = true
          this.disabledInput4 = true
          this.arr4 = data.next
        }
      }
    },
    async shopChange2(value2) {
      this.arr3 = []
      this.arr4 = []
      this.arr5 = []
      this.value3 = ''
      this.value4 = ''
      this.value5 = ''

      this.formInfo.companyId = value2.company_id || ''
      this.formInfo.staffId = value2.rid || ''

      if (!value2) return
      const payload = {
        rid: value2.rid,
        companyId: value2.company_id,
        system: 3
      }
      const data = await this.fetchNextList(payload)
      if (data) {
        this.arr2 = data.next
        this.shopIds = data.shopIds
      }
    },
    async shopChange3(value3) {
      this.arr4 = []
      this.arr5 = []
      this.value4 = ''
      this.value5 = ''

      this.formInfo.companyId = value3.company_id || ''
      this.formInfo.staffId = value3.rid || ''

      if (!value3) return
      const payload = {
        rid: value3.rid,
        companyId: value3.company_id,
        system: 4
      }
      const data = await this.fetchNextList(payload)
      if (data) {
        this.arr3 = data.next
      }
    },
    async shopChange4(value4) {
      this.arr5 = []
      this.value5 = ''

      this.formInfo.companyId = value4.company_id || ''
      this.formInfo.staffId = value4.rid || ''

      if (!value4) return
      const payload = {
        rid: value4.rid,
        companyId: value4.company_id,
        system: 5
      }
      const data = await this.fetchNextList(payload)
      if (data) {
        this.arr4 = data.next
      }
    },
    shopChange5(value5) {
      this.arr8 = []
      this.value8 = ''

      this.formInfo.companyId = value5.companyId || ''
      this.formInfo.merchantId = value5.merchantId || ''
      if (!value5) return
      this.arr8 = value5.sellers.map((item) => {
        item.countryMarks = item.countryMarks.map((key) => {
          return {
            ...key,
            sellerId: item.sellerId
          }
        })
        return item
      })
    },
    shopChange8(value) {
      this.formInfo.companyId = value.companyId || ''
      this.formInfo.merchantId = value.merchantId || ''
      this.formInfo.shopId = value.sellerId || ''
    },
    async shopChange6(value6) {
      this.arr1 = []
      this.arr2 = []
      this.arr3 = []
      this.arr4 = []
      this.arr5 = []
      this.arr7 = []
      this.value1 = ''
      this.value2 = ''
      this.value3 = ''
      this.value4 = ''
      this.value5 = ''
      this.value7 = ''
      this.formInfo.companyId = value6.company_id || ''
      this.formInfo.staffId = value6.rid || ''

      if (!value6) return
      const payload = {
        rid: value6.rid,
        companyId: value6.company_id,
        system: 1
      }
      const data = await this.fetchNextList(payload)
      if (data) {
        this.arr7 = data.next
        this.shopIds = data.shopIds
      }
    },
    async shopChange7(value7) {
      this.arr1 = []
      this.arr2 = []
      this.arr3 = []
      this.arr4 = []
      this.arr5 = []
      this.value1 = ''
      this.value2 = ''
      this.value3 = ''
      this.value4 = ''
      this.value5 = ''

      this.formInfo.companyId = value7.company_id || ''
      this.formInfo.staffId = value7.rid || ''

      if (!value7) return
      const payload = {
        rid: value7.rid,
        companyId: value7.company_id,
        system: 1
      }
      const data = await this.fetchNextList(payload)
      if (data) {
        this.arr1 = data.next
        this.shopIds = data.shopIds
      }
    },
    async fetchNextList(rest) {
      try {
        this.formInfo.companyId = rest.companyId
        const payload = {
          sellerType: 3,
          ...rest
        }
        const url = Baseurl + 'roleController/selectNextAndMerchantInfoByRid'
        const res = await ajaxPost(url, payload)
        const { code, data } = res.data
        if (code === 200) {
          return data
        }
        return false
      } catch (error) {
        console.log(error)
      }
    },
    //选择开始时间
    onStartTimeChange(val) {
      var d = new Date(val)
      var datetime =
        d.getFullYear() +
        '-' +
        (d.getMonth() + 1) +
        '-' +
        d.getDate() +
        ' 00:00:00'
      this.formInfo.startTime = datetime
    },
    // 选择结束时间
    onEndTimeChange(val) {
      var d = new Date(val)
      var datetime =
        d.getFullYear() +
        '-' +
        (d.getMonth() + 1) +
        '-' +
        d.getDate() +
        ' 23:59:59'
      this.formInfo.endTime = datetime
    },
    onSearch() {
      this.$emit('search', this.getFormInfo())
    },
    getFormInfo() {
      return { ...this.formInfo }
    }
  }
}
</script>

<style></style>
